
import React, {  useState,useEffect, createContext } from "react";
// import {getFromLocalStorage} from '../components/helper/task'
const SelectContext=React.createContext()

const SelectProvider=({children})=>{
    
    const [onSelect,setSelect]=useState(null);

        

    return(
    <SelectContext.Provider value={[onSelect,setSelect]}>
        {children}
    </SelectContext.Provider>)
}

export {SelectContext,SelectProvider}



